import React from "react";
import * as Option from "@utils/Option";
import type { OptionTs } from "@ps-bridge/interop";
import EmptyView from "@view/EmptyView";

export const renderWhen = (
  condition: boolean,
  view: React.ReactElement,
): React.ReactElement => {
  const key = condition ? "on" : "off";
  const views: Record<"on" | "off", React.ReactElement> = {
    on: view,
    off: <EmptyView />,
  };
  return views[key];
};

export const renderIf = (
  condition: boolean,
  whenTrue: React.ReactElement,
  whenFalse: React.ReactElement = <EmptyView />,
): React.ReactElement => {
  const key = condition ? "on" : "off";
  const views: Record<"on" | "off", React.ReactElement> = {
    on: whenTrue,
    off: whenFalse,
  };
  return views[key];
};

export const renderOption = <A,>(
  option: OptionTs<A>,
  render: (value: A) => React.ReactElement,
): React.ReactElement => Option.fold(option, () => <EmptyView />, render);
